import React from "react";

const Cell = ({ id }) => {
  return <span className="game-2048-cell"></span>;
};

export default Cell;